// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"306":"learner-dashboard-main","569":"instructor-dashboard-main"}[chunkId] || chunkId) + "." + {"306":"e506d8f62ac1ce0baaba","569":"0de9a25c22228401db77","710":"b900e59142ac3fd67113"}[chunkId] + ".js";
};